import React from 'react';
import moment from 'moment';
import { Colors } from '@common/tokens';

const expiringSoonNotice = (expiringIn: number) => {
  if (expiringIn <= 0) {
    return 'Expiring today';
  }
  if (expiringIn === 1) {
    return `Expiring in ${expiringIn} day`;
  }

  return `Expiring in ${expiringIn} days`;
};

type Props = {
  isExpired: boolean;
  isExpiringSoon: boolean;
  expiresOn?: string;
};

export function ExpirationDetails({
  expiresOn,
  isExpired,
  isExpiringSoon,
}: Props) {
  if (!expiresOn) return null;

  const expiringIn = Math.ceil(moment(expiresOn).diff(moment(), 'days', true));

  return (
    <>
      <span className={isExpired ? 'expired' : ''}>{expiresOn}</span>
      {isExpired && <div className="text-expired">Expired</div>}
      {isExpiringSoon && !isExpired && (
        <div className="text-expiring">{expiringSoonNotice(expiringIn)}</div>
      )}

      <style jsx>{`
        .expired {
          color: ${Colors.coral};
        }
        .text-expired {
          font-weight: 800;
          color: ${Colors.coral};
        }
        .text-expiring {
          font-weight: 100;
          color: ${Colors.coral};
        }
      `}</style>
    </>
  );
}
